import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
import { XML_CHARKEY } from "../util/serializer.common";
import { MapperType } from "../serializer";
import { RestError } from "../restError";
import { parseXML } from "../util/xml";
/**
 * Create a new serialization RequestPolicyCreator that will serialized HTTP request bodies as they
 * pass through the HTTP pipeline.
 */

export function deserializationPolicy(deserializationContentTypes, parsingOptions) {
  return {
    create: function create(nextPolicy, options) {
      return new DeserializationPolicy(nextPolicy, options, deserializationContentTypes, parsingOptions);
    }
  };
}
export var defaultJsonContentTypes = ["application/json", "text/json"];
export var defaultXmlContentTypes = ["application/xml", "application/atom+xml"];
export var DefaultDeserializationOptions = {
  expectedContentTypes: {
    json: defaultJsonContentTypes,
    xml: defaultXmlContentTypes
  }
};
/**
 * A RequestPolicy that will deserialize HTTP response bodies and headers as they pass through the
 * HTTP pipeline.
 */

export var DeserializationPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(DeserializationPolicy, _BaseRequestPolicy);

  var _super = _createSuper(DeserializationPolicy);

  function DeserializationPolicy(nextPolicy, requestPolicyOptions, deserializationContentTypes) {
    var _this;

    var parsingOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, DeserializationPolicy);

    var _a;

    _this = _super.call(this, nextPolicy, requestPolicyOptions);
    _this.jsonContentTypes = deserializationContentTypes && deserializationContentTypes.json || defaultJsonContentTypes;
    _this.xmlContentTypes = deserializationContentTypes && deserializationContentTypes.xml || defaultXmlContentTypes;
    _this.xmlCharKey = (_a = parsingOptions.xmlCharKey) !== null && _a !== void 0 ? _a : XML_CHARKEY;
    return _this;
  }

  _createClass(DeserializationPolicy, [{
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this._nextPolicy.sendRequest(request).then(function (response) {
                  return deserializeResponseBody(_this2.jsonContentTypes, _this2.xmlContentTypes, response, {
                    xmlCharKey: _this2.xmlCharKey
                  });
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendRequest(_x) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  }]);

  return DeserializationPolicy;
}(BaseRequestPolicy);

function getOperationResponse(parsedResponse) {
  var result;
  var request = parsedResponse.request;
  var operationSpec = request.operationSpec;

  if (operationSpec) {
    var operationResponseGetter = request.operationResponseGetter;

    if (!operationResponseGetter) {
      result = operationSpec.responses[parsedResponse.status];
    } else {
      result = operationResponseGetter(operationSpec, parsedResponse);
    }
  }

  return result;
}

function shouldDeserializeResponse(parsedResponse) {
  var shouldDeserialize = parsedResponse.request.shouldDeserialize;
  var result;

  if (shouldDeserialize === undefined) {
    result = true;
  } else if (typeof shouldDeserialize === "boolean") {
    result = shouldDeserialize;
  } else {
    result = shouldDeserialize(parsedResponse);
  }

  return result;
}
/**
 * Given a particular set of content types to parse as either JSON or XML, consumes the HTTP response to produce the result object defined by the request's {@link OperationSpec}.
 * @param jsonContentTypes - Response content types to parse the body as JSON.
 * @param xmlContentTypes  - Response content types to parse the body as XML.
 * @param response - HTTP Response from the pipeline.
 * @param options  - Options to the serializer, mostly for configuring the XML parser if needed.
 * @returns A parsed {@link HttpOperationResponse} object that can be returned by the {@link ServiceClient}.
 */


export function deserializeResponseBody(jsonContentTypes, xmlContentTypes, response) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _a, _b, _c;

  var updatedOptions = {
    rootName: (_a = options.rootName) !== null && _a !== void 0 ? _a : "",
    includeRoot: (_b = options.includeRoot) !== null && _b !== void 0 ? _b : false,
    xmlCharKey: (_c = options.xmlCharKey) !== null && _c !== void 0 ? _c : XML_CHARKEY
  };
  return parse(jsonContentTypes, xmlContentTypes, response, updatedOptions).then(function (parsedResponse) {
    if (!shouldDeserializeResponse(parsedResponse)) {
      return parsedResponse;
    }

    var operationSpec = parsedResponse.request.operationSpec;

    if (!operationSpec || !operationSpec.responses) {
      return parsedResponse;
    }

    var responseSpec = getOperationResponse(parsedResponse);

    var _handleErrorResponse = handleErrorResponse(parsedResponse, operationSpec, responseSpec),
        error = _handleErrorResponse.error,
        shouldReturnResponse = _handleErrorResponse.shouldReturnResponse;

    if (error) {
      throw error;
    } else if (shouldReturnResponse) {
      return parsedResponse;
    } // An operation response spec does exist for current status code, so
    // use it to deserialize the response.


    if (responseSpec) {
      if (responseSpec.bodyMapper) {
        var valueToDeserialize = parsedResponse.parsedBody;

        if (operationSpec.isXML && responseSpec.bodyMapper.type.name === MapperType.Sequence) {
          valueToDeserialize = typeof valueToDeserialize === "object" ? valueToDeserialize[responseSpec.bodyMapper.xmlElementName] : [];
        }

        try {
          parsedResponse.parsedBody = operationSpec.serializer.deserialize(responseSpec.bodyMapper, valueToDeserialize, "operationRes.parsedBody", options);
        } catch (innerError) {
          var restError = new RestError("Error ".concat(innerError, " occurred in deserializing the responseBody - ").concat(parsedResponse.bodyAsText), undefined, parsedResponse.status, parsedResponse.request, parsedResponse);
          throw restError;
        }
      } else if (operationSpec.httpMethod === "HEAD") {
        // head methods never have a body, but we return a boolean to indicate presence/absence of the resource
        parsedResponse.parsedBody = response.status >= 200 && response.status < 300;
      }

      if (responseSpec.headersMapper) {
        parsedResponse.parsedHeaders = operationSpec.serializer.deserialize(responseSpec.headersMapper, parsedResponse.headers.rawHeaders(), "operationRes.parsedHeaders", options);
      }
    }

    return parsedResponse;
  });
}

function isOperationSpecEmpty(operationSpec) {
  var expectedStatusCodes = Object.keys(operationSpec.responses);
  return expectedStatusCodes.length === 0 || expectedStatusCodes.length === 1 && expectedStatusCodes[0] === "default";
}

function handleErrorResponse(parsedResponse, operationSpec, responseSpec) {
  var _a;

  var isSuccessByStatus = 200 <= parsedResponse.status && parsedResponse.status < 300;
  var isExpectedStatusCode = isOperationSpecEmpty(operationSpec) ? isSuccessByStatus : !!responseSpec;

  if (isExpectedStatusCode) {
    if (responseSpec) {
      if (!responseSpec.isError) {
        return {
          error: null,
          shouldReturnResponse: false
        };
      }
    } else {
      return {
        error: null,
        shouldReturnResponse: false
      };
    }
  }

  var errorResponseSpec = responseSpec !== null && responseSpec !== void 0 ? responseSpec : operationSpec.responses.default;
  var streaming = ((_a = parsedResponse.request.streamResponseStatusCodes) === null || _a === void 0 ? void 0 : _a.has(parsedResponse.status)) || parsedResponse.request.streamResponseBody;
  var initialErrorMessage = streaming ? "Unexpected status code: ".concat(parsedResponse.status) : parsedResponse.bodyAsText;
  var error = new RestError(initialErrorMessage, undefined, parsedResponse.status, parsedResponse.request, parsedResponse); // If the item failed but there's no error spec or default spec to deserialize the error,
  // we should fail so we just throw the parsed response

  if (!errorResponseSpec) {
    throw error;
  }

  var defaultBodyMapper = errorResponseSpec.bodyMapper;
  var defaultHeadersMapper = errorResponseSpec.headersMapper;

  try {
    // If error response has a body, try to deserialize it using default body mapper.
    // Then try to extract error code & message from it
    if (parsedResponse.parsedBody) {
      var parsedBody = parsedResponse.parsedBody;
      var parsedError;

      if (defaultBodyMapper) {
        var valueToDeserialize = parsedBody;

        if (operationSpec.isXML && defaultBodyMapper.type.name === MapperType.Sequence) {
          valueToDeserialize = typeof parsedBody === "object" ? parsedBody[defaultBodyMapper.xmlElementName] : [];
        }

        parsedError = operationSpec.serializer.deserialize(defaultBodyMapper, valueToDeserialize, "error.response.parsedBody");
      }

      var internalError = parsedBody.error || parsedError || parsedBody;
      error.code = internalError.code;

      if (internalError.message) {
        error.message = internalError.message;
      }

      if (defaultBodyMapper) {
        error.response.parsedBody = parsedError;
      }
    } // If error response has headers, try to deserialize it using default header mapper


    if (parsedResponse.headers && defaultHeadersMapper) {
      error.response.parsedHeaders = operationSpec.serializer.deserialize(defaultHeadersMapper, parsedResponse.headers.rawHeaders(), "operationRes.parsedHeaders");
    }
  } catch (defaultError) {
    error.message = "Error \"".concat(defaultError.message, "\" occurred in deserializing the responseBody - \"").concat(parsedResponse.bodyAsText, "\" for the default response.");
  }

  return {
    error: error,
    shouldReturnResponse: false
  };
}

function parse(jsonContentTypes, xmlContentTypes, operationResponse, opts) {
  var _a;

  var errorHandler = function errorHandler(err) {
    var msg = "Error \"".concat(err, "\" occurred while parsing the response body - ").concat(operationResponse.bodyAsText, ".");
    var errCode = err.code || RestError.PARSE_ERROR;
    var e = new RestError(msg, errCode, operationResponse.status, operationResponse.request, operationResponse);
    return Promise.reject(e);
  };

  var streaming = ((_a = operationResponse.request.streamResponseStatusCodes) === null || _a === void 0 ? void 0 : _a.has(operationResponse.status)) || operationResponse.request.streamResponseBody;

  if (!streaming && operationResponse.bodyAsText) {
    var text = operationResponse.bodyAsText;
    var contentType = operationResponse.headers.get("Content-Type") || "";
    var contentComponents = !contentType ? [] : contentType.split(";").map(function (component) {
      return component.toLowerCase();
    });

    if (contentComponents.length === 0 || contentComponents.some(function (component) {
      return jsonContentTypes.indexOf(component) !== -1;
    })) {
      return new Promise(function (resolve) {
        operationResponse.parsedBody = JSON.parse(text);
        resolve(operationResponse);
      }).catch(errorHandler);
    } else if (contentComponents.some(function (component) {
      return xmlContentTypes.indexOf(component) !== -1;
    })) {
      return parseXML(text, opts).then(function (body) {
        operationResponse.parsedBody = body;
        return operationResponse;
      }).catch(errorHandler);
    }
  }

  return Promise.resolve(operationResponse);
}